import ErrorBanner from './ErrorBanner';

export default ErrorBanner;
